import type { DataLhIdModule } from '@/utils/data-lh-id/types'

const dataLhIdConfig: { key: keyof DataLhIdModule.DataLhIdParams; prefix: string }[] = [
  { key: 'P', prefix: 'P' },
  { key: 'Z', prefix: 'Z' },
  { key: 'A', prefix: 'A' },
  { key: 'C', prefix: 'C' },
  { key: 'CPRI', prefix: 'CPRI' },
  { key: 'CTI', prefix: 'CTI' },
  { key: 'I', prefix: 'I' }
]

export const generateDataLhId = (params: DataLhIdModule.DataLhIdParams): string => {
  const parts: string[] = []

  for (const item of dataLhIdConfig) {
    if (params[item.key] !== undefined) {
      const value = params[item.key].toString().replaceAll('-', '_').replaceAll(' ', '_').replace(/[\u0300-\u036F]|[^\w\s]/gi, '').toLowerCase()
      parts.push(`${item.prefix}-${value}`)
    }
  }

  return parts.join('-')
}
